export const CaseTypeOptionLabels = {
  CUSTOMER_TICKET: "Single Customer Case",
  INTERNAL_TICKET: "Internal Task",
  PUBLIC_TICKET: "Multi Customer Case",
};
